export default __webpack_public_path__ + "static/media/tickIcon.1f0a4f65.svg";